<template>
  <div>
    <Jumbotron title="Privacy Policy" />

    <b-container class="text-justify pt-3">
      <b-row>
        <b-col>
          <p>
            “Data Pribadi” berarti informasi mengenai anda, dimana anda dapat diidentifikasi, termasuk namun tidak terbatas pada nama, kewarganegaraan, alamat, nomor telepon, nomor faks, rincian bank, rincian kartu kredit, jenis kelamin, status kependudukan, latar belakang keuangan, kepentingan pribadi, alamat email, pekerjaan anda, foto anda, informasi tentang anda yang mana telah anda berikan kepada STARGUIDES dalam formulir pendaftaran, formulir aplikasi atau bentuk serupa lainnya dan/atau informasi tentang anda yang telah atau mungkin dikumpulkan, disimpan, digunakan dan/atau diproses oleh STARGUIDES dari waktu ke waktu dan termasuk data pribadi yang sensitif seperti nomor kartu identitas anda, nomor SIM, nomor, nomor paspor, ras, asal etnis, tanggal lahir, status perkawinan, latar belakang pendidikan, dan data yang berkaitan dengan kesehatan, agama atau kepercayaan sejenis lainnya. Jika anda adalah penyedia layanan, kami mungkin juga mengumpulkan data telematika (seperti data laju kecepatan, akselerasi, dan pengereman anda), data perangkat anda (termasuk nomor IMEI dan nama aplikasi yang telah dilekatkan pada perangkat anda) dan data registrasi kendaraan anda.
          </p>

          <p>
            Penyediaan Data Pribadi anda bersifat sukarela. Namun, jika anda tidak memberikan STARGUIDES Data Pribadi Anda, STARGUIDES tidak akan dapat memproses Data Pribadi anda untuk Tujuan dan Tujuan Tambahan yang diuraikan di bawah ini, dan dapat menyebabkan STARGUIDES tidak dapat memberikan layanan-layanan atau produk-produk kepada, atau menerima pembayaran-pembayaran dari anda.
          </p>

          <p>
            Jika anda adalah agen, vendor, pemasok (supplier) atau penyedia layanan, maka, penyediaan Data Pribadi anda adalah wajib, dan kegagalan untuk menyediakan Data Pribadi anda, dapat melanggar undang-undang atau persyaratan peraturan yang berlaku, dan dapat menyebabkan STARGUIDES Group untuk tidak dapat menngunakan anda dalam memberikan layanan-layanan atau produk-produk atau melakukan pembayaran-pembayaran kepada anda untuk produk-produk atau layanan-layanan yang akan diberikan.
          </p>

          <p>
            <b>Selain Data Pribadi yang anda berikan secara langsung kepada STARGUIDES, STARGUIDES juga dapat mengambil Data Pribadi anda dari sumber-sumber yang tersedia bagi publik atau dari pihak ketiga, contohnya:</b>

            <ol>
              <li>dari pengisian formulir aplikasi atau registrasi, survei, atau formulir serupa lainnya;</li>
              <li>dari halaman media sosial resmi STARGUIDES, jika anda follow, like atau menjadi penggemar halaman tersebut;</li>
              <li>saat anda berinteraksi dan berkomunikasi dengan STARGUIDES di setiap acara-acara (events) atau kegiatan-kegiatan;</li>
              <li>dari berbagai entitas-entitas atau divisi-divisi di bawah STARGUIDES;</li>
              <li>dari entitas lain yang menyediakan layanan bagi anda atau entitas yang memiliki hubungan kontraktual dengan anda;</li>
              <li>dari penyedia atau mitra layanan pemasaran; atau</li>
              <li>dengan menggunakan aplikasi dan situs STARGUIDES, termasuk semua aplikasi dan situs web yang dioperasikan oleh STARGUIDES, dan dibawah nama masing-masing merek tersebut (masing-masing disebut “Aplikasi” dan “Websites”).</li>
            </ol>
          </p>

          <p>
            Data pribadi anda dapat juga diambil dari cookies yang digunakan di Websites, dan jika Anda adalah penyedia layanan, data perangkat, dan data yang diambil pada saat aktifnya aplikasi Guiders anda.
          </p>

          <b>Tujuan Pengolahan</b>

          <p>
            STARGUIDES dapat menggunakan dan memproses Data Pribadi anda untuk usaha, pengiriman dan logistik (termasuk makanan dan minuman) nantinya, STARGUIDES yang mencakup, namun tidak terbatas pada hal berikut (“Tujuan”):
          </p>

          <p>
            <b>Apabila anda adalah pelanggan dari layanan yang diberikan oleh STARGUIDES :</b>
            <ul>
              <li>untuk melakukan kewajiban-kewajiban STARGUIDES sehubungan dengan perjanjian yang ditandatangani dengan Anda;</li>
              <li>untuk memberikan kepada anda layanan yang anda mintakan;</li>
              <li>untuk memproses permintaan langganan anda dan menyampaikan layanannya kepada anda</li>
              <li>di mana anda telah meminta untuk mengunduh dan menggunakan aplikasi STARGUIDES, atau aplikasi STARGUIDES lainnya, untuk memproses permintaan anda, untuk menyampaikan Aplikasi kepada anda dan memberi anda lisensi untuk penggunaan Aplikasi;</li>
              <li>untuk memproses dan mengelola loyalty anda;</li>
              <li>untuk memproses partisipasi anda dalam setiap acara-acara (events), kegiatan-kegiatan, kerja kelompok, studi penelitian, perlombaan, promosi, polling, survei, atau produksi-produksi lainnya;</li>
              <li>untuk memproses, mengelola atau memverifikasi aplikasi anda untuk berlangganan dengan STARGUIDES dan untuk memberi anda keuntungan yang ditawarkan kepada pelanggan;</li>
              <li>untuk memvalidasi pemesanan anda dan memproses pembayaran yang berkaitan dengan produk atau layanan yang anda minta;</li>
              <li>untuk memahami dan menganalisis penjualan kami serta kebutuhan dan preferensi anda</li>
              <li>mengembangkan, meningkatkan dan menyediakan produk-produk dan layanan-layanan untuk memenuhi kebutuhan anda;</li>
              <li>untuk memproses penukaran atau pengembalian produk;</li>
              <li>menggunakan cookies untuk meningkatkan pemrosesan, periklanan, pemberitahuan, otentikasi, keamanan dan kepatuhan, analisis dan manajemen preferensi kami</li>
            </ul>
          </p>

          <p>
            <b>Apabila anda adalah agen, vendor, pemasok, mitra,  atau penyedia layanan:</b>
            <ul>
              <li>bertujuan untuk melibatkan anda dalam memberikan layanan-layanan atau produk-produk;</li>
              <li>untuk memfasilitasi atau memungkinkan adanya pemeriksaan oleh STARGUIDES (apabila dibutuhkan), agar dapat melibatkan anda;</li>
              <li>memproses pembayaran yang berkaitan dengan produk-produk atau layanan-layanan yang anda berikan;</li>
              <li>untuk memberikan jawaban kepada anda, sehingga anda dapat mengidentifikasi area-area yang spesifik untuk diperbaiki;</li>
              <li>untuk menilai keamanan dan kualitas;</li>
              <li>untuk memantau kepatuhan anda kepada syarat dan ketentuan, kebijakan-kebijakan dan Kode Etik Mitra lainnya;</li>
              <li>untuk memberitahukan informasi terbaru kepada mitra penyedia layanan kami untuk kepentingan manajemen pelayanan; atau</li>
              <li>untuk menghubungi anda sehubungan dengan pengadaan pelayanan anda</li>
            </ul>
          </p>

          <p>
            <b>Umum</b>

            <ul>
              <li>untuk menanggapi pertanyaan, komentar dan jawaban dari anda;</li>
              <li>untuk berkomunikasi dengan anda sehubungan dengan segala hal yang disebutkan dalam Kebijakan ini;</li>
              <li>untuk tujuan administratif internal, seperti audit, analisis data, rekaman-rekaman dalam database;</li>
              <li>untuk tujuan mendeteksi/penemuan, pencegahan dan penuntutan tindak pidana;</li>
              <li>untuk menjaga keselamatan dan keamanan layanan kami;</li>
              <li>agar STARGUIDES dapat mematuhi kewajibannya berdasarkan hukum yang berlaku;</li>
            </ul>

            dan anda sepakat dan menyetujui STARGUIDES menggunakan dan memproses Data Pribadi anda untuk Tujuan, dan dengan cara yang disebutkan dalam Kebijakan ini.
          </p>

          <b>Tujuan untuk pemasaran dan promosi</b>

          <p>
            STARGUIDES juga dapat menggunakan dan memproses data anda untuk tujuan lain seperti (“Tujuan Tambahan”):

            <ul>
              <li>mengirimkan suatu pemberitahuan, newsletter, update, surat, materi promosi, hak-hak istimewa, ucapan selamat hari raya dari STARGUIDES, mitranya, sponsor-sponsor atau iklan-iklan;</li>
              <li>memberitahukan dan mengundang anda ke acara-acara (event) atau kegiatan-kegiatan yang diselenggarakan oleh STARGUIDES, mitranya, sponsor-sponsornya atau iklan-iklannya;</li>
              <li>memproses pendaftaran anda untuk berpartisipasi atau menghadiri acara atau kegiatan, dan untuk berkomunikasi dengan anda sehubungan dengan kehadiran anda dalam acara atau kegiatan;</li>
              <li>membagikan Data Pribadi anda di anak-anak perusahaannya, mitra-mitra perusahaan dan entitas-entitas yang dikendalikan olehnya, serta dengan agen, vendor, pemasok, mitra, kontraktor atau penyedia layanan yang mungkin berkomunikasi dengan anda untuk memasarkan produk-produknya, layanan-layanannya, acara-acaranya atau promosi-promosinya;</li>
            </ul>

            melalui pos, telepon, layanan pesan singkat (SMS), layanan pesan online, melalui pemberian secara langsung / atau melalui email.
          </p>

          <b>Berhenti dan Pencabutan Persetujuan</b>

          <p>
            Jika anda ingin berhenti digunakannya Data Pribadi anda untuk Tujuan Tambahan oleh STARGUIDES, mohon untuk dapat meng-klik “Unsubscribe” yang ada dalam email atau pesan yang terkait, agar anda tidak lagi menerima pesan-pesan semacam itu di masa mendatang. Harap perhatikan bahwa jika anda telah menyatakan tidak meneruskan pengolahan Data Pribadi anda, kami mungkin masih mengirimkan pesan terkait layanan kepada anda, seperti bukti perjalanan.
          </p>

          <p>
            Jika anda ingin mencabut persetujuan yang STARGUIDES telah dapatkan dari anda sehubungan dengan Tujuan yang dimaksud dalam Kebijakan ini, mohon memberitahukan kepada STARGUIDES dengan menggunakan rincian kontak yang disebutkan.
          </p>

          <b>Pengalihan Data Pribadi</b>

          <p>
            Data Pribadi anda mungkin akan ditransfer ke, disimpan, digunakan dan diproses di yurisdiksi lain selain negara asal anda atau mungkin di suatu negara, negara bagian dan kota dimana anda sedang berada pada saat menggunakan layanan yang diberikan oleh STARGUIDES (“Negara Lain”), ke perusahaan-perusahaan di bawah STARGUIDES yang berada di luar negara asal anda atau Negara Lain dan/atau di mana server STARGUIDES dan/atau penyedia layanan dan mitra STARGUIDES berada yang di luar negara asal anda atau Negara Lain. Anda mengerti dan menyetujui peralihan Data Pribadi anda dari negara asal anda atau Negara Lain sebagaimana disebutkan dalam Kebijakan ini.
          </p>

          <b>Pengungkapan kepada Pihak Ketiga</b>

          <p>
            Data Pribadi anda dapat ditransfer, dinilai atau diungkapkan kepada pihak ketiga untuk Tujuan dan Tujuan Tambahan. Lebih lanjut, STARGUIDES dapat menggunakan perusahaan-perusahaan lain, penyedia jasa atau perorangan untuk melakukan fungsinya atas nama STARGUIDES, dan bersamaan juga dapat memberikan akses atau mengungkapkannya ke Data Pribadi anda kepada penyedia layanan tersebut atau pihak ketiga.
            <br>
            Para pihak ketiga termasuk, namun tidak terbatas pada:

            <ul>
              <li>mitra STARGUIDES, termasuk pihak-pihak dengan siapa STARGUIDES bekerja sama untuk acara-acara, program-program dan kegiatan-kegiatan tertentu;</li>
              <li>Pengiklanan;</li>
              <li>Perusahaan-perusahaan manajemen acara dan sponsor acara-acara;</li>
              <li>Perusahaan-perusahaan riset pemasaran;</li>
              <li>Penyedia layanan, termasuk, penyedia layanan teknologi informasi (IT) untuk pekerjaan infrastruktur, perangkat lunak dan pembangunan;</li>
              <li>Penasihat profesional dan auditor eksternal, termasuk penasihat hukum, penasihat keuangan dan konsultan;</li>
              <li>Entitas lain dalam STARGUIDES; dan</li>
              <li>Pemerintahan yang berwenang untuk mematuhi persyaratan-persyaratan perundang-undangan, peraturan-peraturan dan pemerintahan.</li>
            </ul>

            Data Pribadi anda juga dapat dibagikan sehubungan dengan adanya transaksi perusahaan, seperti pembentukan perusahaan patungan, penjualan anak perusahaan atau divisi, penggabungan, konsolidasi, atau penjualan aset, atau likuidasi.
          </p>

          <b>Permintaan Akses & Koreksi dan Pertanyaan, Membatasi Penggunaan Data Pribadi</b>

          <p>
            Dengan tunduk pada adanya pengecualian menurut undang-undang negara asal anda yang berlaku, anda dapat meminta akses dan/atau meminta koreksi Data Pribadi anda, meminta untuk membatasi penggunaan Data Pribadi anda untuk Tujuan Tambahan dan/atau membuat pertanyaan mengenai Data Pribadi anda dengan menghubungi:

            STARGUIDES
            <br>
            Jalan Gading Serpong Boulevard Kav M5 No.17-18, Kelapa Dua, Curug Sangereng
            <br>
            Tangerang 15810,
            <br>
            Indonesia
            <br>
            Email: partnership@starguides.com
          </p>

          <p>
            Dengan tunduk pada undang-undang negara asal anda atau Negara Lain, STARGUIDES berhak mengenakan biaya untuk mengakses Data Pribadi anda sesuai jumlah yang disetujui di dalamnya.
          </p>

          <p>
            Sehubungan dengan hak anda untuk mengakses dan/atau memperbaiki Data Pribadi anda, STARGUIDES berhak menolak permintaan anda untuk mengakses dan/atau membuat koreksi terhadap Data Pribadi anda karena alasan yang dipersyaratkan berdasarkan undang-undang, seperti di mana biaya penyediaan akses kepada anda tidak proporsional dengan risiko privasi anda atau orang lain.
          </p>

          <b>Cookies</b>

          <p>
            STARGUIDES, dan pihak ketiga yang menjadi mitra kami, dapat menggunakan cookies, web beacons, tags, scripts, objek lokal yang dibagikan seperti HTML5 dan Flash (yang secara umum biasa disebut “flash cookies”), advertising identifiers (termasuk pengenal seluler seperti Apple’s IDFA atau Google’s Advertising ID) dan teknologi serupa (“Cookies”) sehubungan dengan penggunaan Websites dan Aplikasi anda. Cookies memiliki pengenalan unik, dan berada, di tempat-tempat lain, di komputer atau perangkat seluler anda, di e-mail yang kami kirim kepada anda, dan di halaman web kami. Cookies dapat mengirimkan informasi tentang anda dan penggunaan Layanan oleh anda, seperti jenis browser, preferensi pencarian dan alamat IP anda, data yang berkaitan dengan iklan yang telah ditampilkan kepada anda atau yang telah anda klik, dan tanggal dan waktu penggunaan anda. Cookies akan persisten atau disimpan hanya pada sesi individual.
          </p>

          <p>
            STARGUIDES dapat mengizinkan pihak ketiga untuk menggunakan Cookies di Websites dan Aplikasi untuk mengumpulkan jenis informasi yang sama dalam tujuan yang sama seperti yang dilakukan STARGUIDES untuknya. Pihak ketiga mungkin dapat menghubungkan informasi yang mereka kumpulkan dengan informasi lain yang mereka miliki tentang anda dari sumber lain. Kami tidak memiliki akses terhadap atau kontrol atas Cookies yang mereka gunakan.
          </p>

          <p>
            Selain itu, kami juga dapat membagikan informasi non-personal dari atau tentang anda kepada pihak ketiga, seperti data lokasi, advertising identifiers, atau cryptographic hash dari common account identifier (seperti alamat e-mail), untuk memfasilitasi tampilan iklan yang ditargetkan.
            <br>
            Jika anda tidak ingin Data Pribadi anda dikumpulkan melalui Cookies di Websites, anda dapat menonaktifkan cookies dengan menyesuaikan pengaturan browser internet anda untuk menonaktifkan, memblokir atau menonaktifkan cookies, dengan menghapus riwayat penjelajahan anda dan membersihkan cache dari browser internet anda. Anda juga dapat membatasi pembagian beberapa informasi ini melalui pengaturan perangkat seluler anda, atau dengan mengirimkan detail anda.
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'PrivacyAndPolicy',
  components: {
    'Jumbotron': Jumbotron
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Static/PrivacyAndPolicy.vue